<template>
    <v-form @submit.prevent="addEditBankDetails" ref="form">
        <v-card dense style="border-radius:4px;">
            <v-toolbar flat height="45px">
                <span class="font-weight-bold ">{{mode}} Bank Details</span>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeDialog()" >
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{ errorMessage }}
            </v-alert> 
            <v-card-text >
                <v-layout row wrap style="margin:0px 20px 0px 20px;">  
                    <v-flex xs12> 
                        <v-select
                            label="Select bank"
                            :items="banks"
                            :rules="[rules.required]" 
                            item-text="bankName"
                            item-value="bankId"
                            :disabled="disabled"
                            v-model="bankId"
                        ></v-select>
                    </v-flex>
                </v-layout>
                <v-layout row wrap style="margin: -10px 20px 0px 20px;">  
                    <v-flex xs12> 
                        <v-textarea v-model="bankBranch" :rules="[rules.required]"  label="Bank Branch" rows="1" color="primary"></v-textarea>
                    </v-flex>
                </v-layout>
                <v-layout row wrap style="margin: -10px 20px 0px 20px;">  
                    <v-flex xs12> 
                        <v-text-field label="Bank Account" 
                            v-model="bankAccount" 
                            :disabled="disabled"
                            :rules="[rules.required]"
                            type="number"
                            ></v-text-field>  
                    </v-flex>
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" type="submit" :loading="loading">Save</v-btn>
                <v-btn v-if="mode!='Update'" @click="clearForm" :disabled="disabled" >clear</v-btn>
            </v-card-actions>
        </v-card>
  </v-form>
</template>
<script>

import banksApi from '@/api/banks'

export default {
    name: 'dialog',
    data () {
        return {
            mode: null,
            loading: false,
            disabled: false,   
            rules: {
                required: value => !!value || 'Required.'
            },
            error: false,
            errorMessage: '',
            banks: [],
            userId: null,
            bankId: null,
            bankBranch: null,
            bankAccount: null,
            mode: null
        }
    },
    methods: {
        async setParams(data) {
            if (this.banks.length==0) await this.getBanks()

            this.userId = data.userId
            this.mode = 'Add'
            if (data.bankDetails != null) {
                this.mode = 'Update'
                this.bankId = data.bankDetails.bankId
                this.bankBranch = data.bankDetails.bankBranch
                this.bankAccount = data.bankDetails.bankAccount
            }
        },
        async getBanks() {
            try {
                this.loading = true

                const response = await banksApi.getAll()
                if (response.status==200) {
                    this.banks = response.data.items
                }

                this.loading = false
            }catch(error) {
                this.errorMessage = error
                this.error = true
            }
        },
        async addEditBankDetails() {
            if (this.$refs.form.validate()) {
                try{
                    this.loading = true
                    this.disabled = true
                    
                    var response = null
                    var data = {
                        userId: this.userId,
                        bankId: this.bankId,
                        bankBranch: this.bankBranch,
                        bankAccount: this.bankAccount
                    }
                    if (this.mode == 'Add')
                        response = await banksApi.add(data)
                    else
                        response = await banksApi.update(data)
                    
                    if (response.status==200) {
                        this.closeDialog()
                        this.$emit('send', '')
                    }

                    this.loading = false
                    this.disabled = false
                }catch(error) {
                    this.errorMessage = error
                    this.error = true
                }
            }
        },
        closeDialog() {
            this.$emit('update:dialogUpdateBank', false)
            this.clearForm()
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        }
    },
    computed: {},
    created() {}
}
</script>